import { style } from '@vanilla-extract/css';

export const ContainerClass = style({
  width: '80%',
});
